var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"pa-4"},[_c('v-card-title',[_vm._v("Extractos Registrados")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.extractos,"items-per-page":10,"dense":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }